'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VLabel = undefined;

var _VLabel = require('./VLabel');

var _VLabel2 = _interopRequireDefault(_VLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.VLabel = _VLabel2.default;
exports.default = _VLabel2.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VLabel/index.js
// module id = 161
// module chunks = 0